

import React from 'react';
import { ChartWidget } from '../widgets';
import type { DashboardMonth } from '../../useDashboard';

interface ChartsSectionProps {
  monthly: DashboardMonth[];
}

export function ChartsSection({ monthly }: ChartsSectionProps) {
  const eventData = monthly.map((m) => ({ name: m.label, Revenue: m.revenue, Profit: m.profit }));
  const cashData = monthly.map((m) => ({ name: m.label, Received: m.received, Spent: m.spent }));
  const hasEvents = monthly.some((m) => m.revenue !== 0 || m.profit !== 0);
  const hasCash = monthly.some((m) => m.received !== 0 || m.spent !== 0);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
      <ChartWidget
        title="Event revenue and profit"
        subtitle="By the month each event starts · after discount, before tax · cancelled events left out"
        type="bar"
        data={hasEvents ? eventData : []}
        emptyMessage="No events in the last 7 months"
        dataKeys={[
          { key: 'Revenue', color: '#C9A84C', label: 'Revenue' },
          { key: 'Profit', color: '#10B981', label: 'Profit' },
        ]}
        height={260}
      />

      <ChartWidget
        title="Money received and spent"
        subtitle="By payment date · spent = expenses + vendor payments"
        type="line"
        data={hasCash ? cashData : []}
        emptyMessage="No payments in the last 7 months"
        dataKeys={[
          { key: 'Received', color: '#16A34A', label: 'Received' },
          { key: 'Spent', color: '#EF4444', label: 'Spent' },
        ]}
        height={260}
      />
    </div>
  );
}
